import React from 'react';

import { Chip, ChipProps } from '@infoods/lifebase-ui';
import classNames from 'classnames';

import classes from './FoodTagChip.module.scss';
import { FoodTagName } from '../../constants/foodTagName';

type FoodTagChipProps = {
  label: FoodTagName | string;
} & Pick<ChipProps, 'size' | 'className' | 'onDelete' | 'disabled' | 'tabIndex'>;

const FoodTagChip = ({ label, className, ...props }: FoodTagChipProps) => {
  const chipClasses = classNames(classes.tag, className);

  return (
    <Chip
      className={chipClasses}
      data-tag-name={label} // use to set tag color
      label={label}
      color="default" // as fallback color
      {...props}
    />
  );
};

export { FoodTagChip };
